<div class="d-flex flex-column align-items-center px-4 overflow-hidden bg-white rounded-2">
    <adapt-team-guidance-dashboard-element [team]="team"
                                           dashboardTitle="Team guidance"></adapt-team-guidance-dashboard-element>
</div>
